/**
 * Verification tab — reviewer-facing Layer 5/6 tooling for a batch:
 *   - Workbook comparison: parallel-run reconciliation vs the legacy workbook.
 *   - Backfill: the certify-before-submit gate for historical batches.
 *
 * Reads are open to any role; the record/certify actions are gated to
 * reviewer/admin inside each panel (and enforced server-side).
 */

import { Divider, Stack } from "@mantine/core";
import type { BatchDetail } from "../../api/types";
import { BackfillPanel } from "../../components/verification/BackfillPanel";
import { WorkbookComparisonPanel } from "../../components/verification/WorkbookComparisonPanel";

export function VerificationTab({ batch }: { batch: BatchDetail }) {
  return (
    <Stack gap="xl">
      <WorkbookComparisonPanel batch={batch} />
      <Divider />
      {/* Keyed by batch id: BackfillPanel seeds its status from a session cache
          in a useState initializer that wouldn't rerun if this tab stayed
          mounted across a batch switch — remounting resets it for the new batch. */}
      <BackfillPanel key={batch.batch_id} batch={batch} />
    </Stack>
  );
}
